import { useCallback } from "react";
import type { PageViewEvent } from "./events";

const sessionStorageKey = "gtm_last_page_view";

export function useLastPageView() {
  const getLastPageView = useCallback(() => {
    const storedPageView = sessionStorage.getItem(sessionStorageKey);
    if (storedPageView) {
      return JSON.parse(storedPageView) as PageViewEvent;
    }
    return null;
  }, []);

  const setLastPageView = useCallback((pageView: PageViewEvent) => {
    sessionStorage.setItem(sessionStorageKey, JSON.stringify(pageView));
  }, []);

  return { getLastPageView, setLastPageView };
}
